import type { ToggleButtonDesignTokens } from '@primeuix/themes/types/togglebutton'

export default {
  icon: {
    color: '{text.muted.color}',
    hoverColor: '{text.muted.color}',
    checkedColor: '{highlight.color}',
    disabledColor: '{form.field.disabled.color}',
  },
  root: {
    lg: {
      padding: '0.75rem 1.25rem',
      fontSize: '{form.field.lg.font.size}',
    },
    sm: {
      padding: '0.5rem 0.75rem',
      fontSize: '{form.field.sm.font.size}',
    },
    gap: '0.5rem',
    color: '{form.field.color}',
    padding: '0.625rem 1rem',
    focusRing: {
      color: '{form.field.focus.ring.color}',
      style: '{form.field.focus.ring.style}',
      width: '{form.field.focus.ring.width}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    background: '{form.field.background}',
    fontWeight: '500',
    hoverColor: '{form.field.color}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{content.border.radius}',
    checkedColor: '{highlight.color}',
    disabledColor: '{form.field.disabled.color}',
    checkedBackground: '{highlight.background}',
    checkedBorderColor: '{form.field.border.color}',
    disabledBackground: '{form.field.disabled.background}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    transitionDuration: '{form.field.transition.duration}',
    disabledBorderColor: '{form.field.disabled.background}',
  },
  content: {
    lg: {
      padding: '0',
    },
    sm: {
      padding: '0',
    },
    padding: '0',
    borderRadius: '0',
    checkedShadow: 'none',
    checkedBackground: 'transparent',
  },
  colorScheme: {
    dark: {
      root: {
        hoverBackground: '{surface.800}',
      },
    },
    light: {
      root: {
        hoverBackground: '{surface.100}',
      },
    },
  },
} satisfies ToggleButtonDesignTokens
